import { render, staticRenderFns } from "./TicketingFakePaymentMethodPopup.vue?vue&type=template&id=a0bc8b56"
import script from "./TicketingFakePaymentMethodPopup.vue?vue&type=script&lang=ts"
export * from "./TicketingFakePaymentMethodPopup.vue?vue&type=script&lang=ts"
import style0 from "./TicketingFakePaymentMethodPopup.vue?vue&type=style&index=0&id=a0bc8b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports